<script>
import navegacion from './elements/Navegacion.vue'
import presentacionesQuicktable from '../Presentaciones/quicktable.vue'
export default {
    name: 'CatalogosPresentaciones',
    components: { navegacion, presentacionesQuicktable },
    methods: {
        catLoaded() {
            if (!!this.$refs && !!this.$refs.nutricionales) {
                this.$refs.nutricionales.refresh()
            }
        }
    }
}
</script>

<template>
    <div id="CatalogosPresentaciones">
        <navegacion class="mb-4"/>
        <presentaciones-quicktable disable-new-modal />
    </div>
</template>